var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.181641,
    y: 0.507812,
    width: 40.0674,
    height: 41.3599,
    rx: 20.0337,
    fill: "#4E5DCA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1047_10864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3025 16.874V11.2309C23.1007 11.5323 23.8257 12 24.4295 12.6028L27.4357 15.6108C28.0392 16.2138 28.5072 16.9386 28.8085 17.7368H23.1654C22.9365 17.7368 22.7171 17.6459 22.5552 17.4841C22.3934 17.3223 22.3025 17.1028 22.3025 16.874ZM29.2054 19.881V27.2283C29.204 28.3721 28.749 29.4686 27.9402 30.2774C27.1314 31.0862 26.0349 31.5412 24.8911 31.5425H16.2625C15.1187 31.5412 14.0222 31.0862 13.2134 30.2774C12.4046 29.4686 11.9496 28.3721 11.9482 27.2283V15.1483C11.9496 14.0045 12.4046 12.9079 13.2134 12.0991C14.0222 11.2903 15.1187 10.8354 16.2625 10.834H20.1583C20.299 10.834 20.4379 10.8452 20.5768 10.8547V16.874C20.5768 17.5605 20.8495 18.2189 21.335 18.7044C21.8204 19.1898 22.4788 19.4625 23.1654 19.4625H29.1847C29.1942 19.6015 29.2054 19.7404 29.2054 19.881ZM22.3025 27.2283C22.3025 26.9994 22.2116 26.7799 22.0498 26.6181C21.888 26.4563 21.6685 26.3654 21.4397 26.3654H17.1254C16.8965 26.3654 16.6771 26.4563 16.5152 26.6181C16.3534 26.7799 16.2625 26.9994 16.2625 27.2283C16.2625 27.4571 16.3534 27.6766 16.5152 27.8384C16.6771 28.0002 16.8965 28.0911 17.1254 28.0911H21.4397C21.6685 28.0911 21.888 28.0002 22.0498 27.8384C22.2116 27.6766 22.3025 27.4571 22.3025 27.2283ZM24.8911 23.7768C24.8911 23.548 24.8002 23.3285 24.6384 23.1667C24.4765 23.0049 24.2571 22.914 24.0282 22.914H17.1254C16.8965 22.914 16.6771 23.0049 16.5152 23.1667C16.3534 23.3285 16.2625 23.548 16.2625 23.7768C16.2625 24.0057 16.3534 24.2251 16.5152 24.387C16.6771 24.5488 16.8965 24.6397 17.1254 24.6397H24.0282C24.2571 24.6397 24.4765 24.5488 24.6384 24.387C24.8002 24.2251 24.8911 24.0057 24.8911 23.7768Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1047_10864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7086,
    height: 20.7086,
    fill: "white",
    transform: "translate(10.2217 10.834)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocBlue);
export default __webpack_public_path__ + "static/media/icon-doc-blue.26d0688791f9ebbf78f5f08bd7c7f80e.svg";
export { ForwardRef as ReactComponent };